module.exports = __webpack_public_path__ + "media/select-click-1109.cda24e90.wav";